export function createLocalAudioStartup(startAudio) {
  let startupPromise = null

  function start() {
    if (!startupPromise) {
      startupPromise = Promise.resolve().then(startAudio)
    }
    return startupPromise
  }

  async function runAfterStart(operation) {
    try {
      await start()
    } catch (error) {
      return { skipped: true, error }
    }
    return operation()
  }

  return { start, runAfterStart }
}
